import React from 'react';
import AvatarBuilder from '../components/AvatarBuilder';

export default function CreateAvatar() {
  return <AvatarBuilder mode="create" />;
}
